import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";
import { setController } from "../services/image_modal_service";

export default class extends Controller {
  static targets = ["img", "title", "nextBtn"];

  connect() {
    setController(this);
    this.modal = new bootstrap.Modal(this.element);
  }

  show(url, title) {
    this.urls = Array.isArray(url) ? url : [url];
    this.nextBtnTargets.forEach(
      (t) => (t.style.display = this.urls.length > 1 ? "" : "none"),
    );
    this.titleTarget.innerText = title;
    this.imgTarget.src = this.urls[0];
    this.modal.show();
  }

  nextThumbnail({ params: { direction } }) {
    let index = this.urls.findIndex((url) => url == this.imgTarget.src);
    const length = this.urls.length;
    index += direction;
    const newIndex = ((index % length) + length) % length;
    this.imgTarget.src = this.urls[newIndex];
  }
}
